// extracted by mini-css-extract-plugin
export default {"admin_content_area":"privacyPolicy_admin_content_area__QzT8t","modal_root":"privacyPolicy_modal_root__J3fNR"};